import axios from 'axios';

// API URL: env wins, else by hostname
const getApiUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  const port = window.location.port;
  if (hostname === 'react.optieportfolio.nl' || hostname.includes('optieportfolio.nl')) {
    return `${protocol}//api.optieportfolio.nl/api`;
  }
  if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname.startsWith('192.168.')) {
    return 'http://192.168.1.166:8888/api';
  }
  return `${protocol}//${hostname}${port ? ':' + port : ''}/api`;
};

export const API_URL = getApiUrl();

/** DRF Token auth (Authorization: Token …). Clears Basic auth. Pass null to remove. */
export function setApiToken(token) {
  if (token) {
    axios.defaults.headers.common.Authorization = `Token ${token}`;
  } else {
    delete axios.defaults.headers.common.Authorization;
  }
  delete axios.defaults.auth;
}

